export class FederalRegistration {
  static isValid(value: string) {
    return value.replace(/[.-]/g, "").length === 9;
  }

  constructor(private value: string) {}

  getFederalRegistration(): string {
    return this.value;
  }
}
